
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/vinterdack",
      function () {
        return require("private-next-pages/tyres/vinterdack.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/vinterdack"])
      });
    }
  